/**
 *  开发完单页面组件请在这里注册
 *  前台根据权限编号去匹配相应组件
 *  开发时组件的name须与权限权限树的编号一致
 *  找不到匹配的组件将匹配默认组件common-grid.vue
 */
import ServiceDocumentShow from './grid/service/service-document-show'
import ServiceDocumentEdit from './grid/service/service-document-edit'
import RedisCacheManage from './grid/develop/redis-cache-manage'
import SetAnalyseConfigDetail from './page/analyse/config/set-analyse-config-detail'
import AnalyseBoard from './page/analyse/show/analyse-board'
import ScheduleJob from './grid/scheduler/schedule-job'
import ScheduleTrigger from './grid/scheduler/schedule-trigger'
import ScheduleRecord from './grid/scheduler/schedule-record'
import TradeSearch from './grid/pay/trade-search'
import BasicMailGrid from './grid/basic-mail-grid.vue'
import ServiceUsageRecord from './grid/service-usage-record'
import ToServiceRecord from './grid/to-service-record'
import SmsTaskRecord from './grid/notification/sms-task-record.vue'
import SmsSendRecordVo from './grid/notification/sms-send-record-vo.vue'
import EmailTaskRecord from './grid/notification/email-task-record.vue'
import EmailSendRecordVo from './grid/notification/email-send-record-vo.vue'
import WxTemplateTaskRecord from './grid/notification/wx-template-task-record.vue'
import WxTemplateSendRecordVo from './grid/notification/wx-template-send-record-vo.vue'
import apiServiceShow from './grid/api-service-show.vue'
import AppTaskRecord from './grid/notification/app-task-record'
import BizStatsTip from './grid/biz-stats-tip'
import clusterInfoServiceConfig from './nginxconfig/clusterInfo-service-config.vue'
import clusterPermissionServiceView from './nginxconfig/clusterPermission-service-view.vue'
import LundaoShareConfig from './paper/lundao-share-config.vue'
import PaperWithdrawalInfo from './paper/paper-withdrawal-info.vue'
import LundaoDashboard from './paper/lundao-dashboard.vue'
import SqlExecutor from './sql-executor/sql-executor.vue'
import MessageStats from './stats/message-stats/message-stats.vue'
import PayStats from './stats/pay-stats/pay-stats.vue'
import FaceStats from './stats/face-stats/face-stats.vue'
import InvoiceStats from './stats/invoice-stats/invoice-stats.vue'

const customComponentsMap = {}

// 定义的组件写到这个数组中
const customComponents = [
  BasicMailGrid, ServiceDocumentShow, ServiceDocumentEdit, RedisCacheManage, SetAnalyseConfigDetail, AnalyseBoard, ScheduleJob,
  ScheduleTrigger, ScheduleRecord, TradeSearch, ServiceUsageRecord, ToServiceRecord, SmsTaskRecord, SmsSendRecordVo, WxTemplateTaskRecord,
  WxTemplateSendRecordVo, apiServiceShow, EmailTaskRecord, EmailSendRecordVo, AppTaskRecord, BizStatsTip, clusterInfoServiceConfig, clusterPermissionServiceView,
  LundaoShareConfig, PaperWithdrawalInfo, LundaoDashboard, SqlExecutor, MessageStats, PayStats, FaceStats, InvoiceStats
]

for (let i = 0; i < customComponents.length; i++) {
  customComponentsMap[customComponents[i].name] = customComponents[i]
}

export default customComponentsMap



// WEBPACK FOOTER //
// ./src/custom/components/custom-components-register.js